import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Typography from '../../../components/common/Typography';

const TooltipContainer = styled.div`
  position: relative;
  width: 100%;
`;

const TooltipArrow = styled.div`
  width: 16px;
  height: 8px;
  margin-left: 20px;
  background: #f4f3ff;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
`;

const TooltipContent = styled.div`
  border-radius: 8px;
  padding: 16px;
  background: #f4f3ff;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TooltipImage = styled.img`
  width: 100%;
  border-radius: 4px;
`;

const FieldTooltip = ({ description, image, isOpen }) => {
  const { t } = useTranslation('previousEmployment');

  if (!isOpen) return null;

  return (
    <TooltipContainer>
      <TooltipArrow />
      <TooltipContent>
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-line' }}>
          {description}
        </Typography>
        {/* 설명 이미지 */}
        {image && <TooltipImage src={image} alt={t('tooltip.imageAlt')} />}
      </TooltipContent>
    </TooltipContainer>
  );
};

export default FieldTooltip;
